module.exports = __webpack_public_path__ + "static/media/misc-fr.46852ef8.jpg";